import type { App, ObjectDirective, DirectiveBinding } from 'vue'
import loading from '@/assets/svgs/common/imgload.svg' // 加载中图片
import error from '@/assets/svgs/common/imgerror.svg' // 加载失败图片

const lazy: ObjectDirective = {
  mounted(el: HTMLImageElement, binding: DirectiveBinding) {
    loading && error && binding
    // 设置占位图
    const imgArr = el.querySelectorAll('img')
    imgArr.forEach((dom) => {
      dom?.setAttribute('loading', 'lazy')
    })
  }
}

const directiveObj = { lazy }

export const setupDirective = (app: App<Element>) => {
  for (const i in directiveObj) {
    app.directive(i, directiveObj[i])
  }
}
